import { useState } from "react";
import { Upload, X } from "lucide-react";
import { BACKEND_URL } from "../../context/AuthContext";

const UploadMusicModal = ({ show, onClose, authToken }) => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState('');

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    setProgress('Uploading to your station...');
    try {
      const formData = new FormData();
      formData.append('file', file);
      const headers = {};
      if (authToken) headers['Authorization'] = `Bearer ${authToken}`;
      const res = await fetch(`${BACKEND_URL}/api/station/upload-music`, { method: 'POST', headers, body: formData });
      if (res.ok) {
        const data = await res.json();
        setProgress(`Uploaded: ${data.filename} successfully!`);
        setTimeout(() => { setProgress(''); onClose(); }, 2000);
      } else {
        const err = await res.json();
        setProgress(`Error: ${err.detail || 'Upload failed'}`);
      }
    } catch { setProgress('Error: Failed to upload'); }
    finally { setUploading(false); }
  };

  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-gray-900 rounded-2xl p-6 max-w-md w-full border border-white/10">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-green-500/20 rounded-full flex items-center justify-center"><Upload className="w-5 h-5 text-green-400" /></div>
            <div><h2 className="text-xl font-bold text-white">Upload Music</h2><p className="text-white/50 text-sm">Add tracks to your station</p></div>
          </div>
          <button onClick={onClose} className="text-white/50 hover:text-white"><X className="w-6 h-6" /></button>
        </div>
        <label className="block cursor-pointer">
          <input type="file" accept="audio/*" onChange={handleUpload} className="hidden" disabled={uploading} />
          <div className="border-2 border-dashed border-white/20 hover:border-purple-500/50 rounded-xl p-8 text-center transition">
            <Upload className="w-12 h-12 text-white/30 mx-auto mb-4" />
            <p className="text-white/70">{uploading ? 'Uploading...' : 'Click to select audio file'}</p>
            <p className="text-white/40 text-sm mt-2">MP3, FLAC, WAV, OGG - Max 100MB</p>
          </div>
        </label>
        {progress && <div className={`mt-4 text-sm text-center ${progress.startsWith('Error') ? 'text-red-400' : progress.startsWith('Uploaded') ? 'text-green-400' : 'text-white/70'}`}>{progress}</div>}
      </div>
    </div>
  );
};

export default UploadMusicModal;
